import base from './base'

let controller = 'guarantor'
let action = null

const Guarantor = {
  async listPublishedGuarantors (query, pageIndex = 1, pageSize = 20) {
    let querys = {
      currentPage: pageIndex || query.pageIdex,
      pageSize: pageSize || query.pageSize,
      sort: query.sort,
      ascending: query.ascending
    }
    Object.assign(querys, query)
    action = 'ListPublishedGuarantors'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async listGuarantors (query, pageIndex = 1, pageSize = 20) {
    let querys = {
      currentPage: pageIndex || query.pageIdex,
      pageSize: pageSize || query.pageSize,
      sort: query.sort,
      ascending: query.ascending
    }
    Object.assign(querys, query)
    querys.isLocal = query.isLocal !== null ? query.isLocal ? true : false : null
    action = 'ListGuarantors'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async listIndustrialGuarantors (query) {
    let querys = {
      industryId: null,
      industryName: null,
      cityId: null,
      cityName: null,
      guarantorId: null,
      guarantorName: null,
      varieties: null,
      needAudit: null
    }
    Object.assign(querys, query)
    action = `ListIndustrialGuarantors`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async listRegionalGuarantors (query) {
    let querys = {
      cityId: null,
      cityName: null,
      guarantorId: null,
      guarantorName: null,
      varieties: null,
      needAudit: null
    }
    Object.assign(querys, query)
    action = `ListRegionalGuarantors`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async getGuarantorDetail (guarantorId) {
    if (!guarantorId) {
      throw new Error('GuarantorId为空')
    }
    action = `Detail/${guarantorId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async getMyGuarantorDetail () {
    action = `GetMyGuarantor`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async getGuarantorUsers (guarantorId) {
    if (!guarantorId) {
      throw new Error('GuarantorId为空')
    }
    action = `GetGuarantorUsers/${guarantorId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async addUesrToGuarantor (guarantorId, userId, isAdmin = true) {
    if (!guarantorId || !userId) {
      throw new Error('GuarantorId或UserId为空')
    }
    action = `AddUser/${guarantorId}/${userId}/${isAdmin}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async removeUesrFromGuarantor (guarantorId, userId) {
    if (!guarantorId || !userId) {
      throw new Error('guarantorId或UserId为空')
    }
    action = `RemoveUser/${guarantorId}/${userId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async removeUesrFromGuarantorById (tid) {
    if (!tid) {
      throw new Error('tid为空')
    }
    action = `RemoveUser/${tid}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async setAllowance (request) {
    if (!request.timestamp) {
      request.timestamp = Date.now()
    }
    action = 'SetGuarantorAllowance'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async submitDraft (request) {
    if (!request.name || !request.businessLicense ||
        !request.contact || !request.contactTel) {
      throw new Error('名称、社会信用代码、联系人、联系人电话不能为空')
    }
    action = 'Draft'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async submitNewGuarantor (request) {
    if (!request.name || !request.businessLicense ||
      !request.contact || !request.contactTel) {
      throw new Error('名称、社会信用代码、联系人、联系人电话不能为空')
    }
    action = 'Submit'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async reSubmitNewGuarantor (request) {
    action = 'ReSubmit'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async addGuarantor (request) {
    action = 'Create'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async addGuarantorAndUser (request) {
    action = 'CreateGuarantorAndUser'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async getGuarantorCities (guarantorId) {
    action = `GetGuarantorCities/${guarantorId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: null
    }
    return base.request(reqModel)
  },

  async getGuarantorIndustries (guarantorId, cityId = 0) {
    action = `GetGuarantorIndustries/${guarantorId}/${cityId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: null
    }
    return base.request(reqModel)
  },

  async getMyPermittedCities () {
    action = 'MyPermittedCities'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: null
    }
    return base.request(reqModel)
  },

  async getMyPermittedIndustries (cityId = 0) {
    action = `MyPermittedIndustries/${cityId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: null
    }
    return base.request(reqModel)
  },

  async listJointGuarantors (cityId = null, industryId = null) {
    action = `ListAvaliableJointGuarantors/${cityId}/${industryId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: null
    }
    return base.request(reqModel)
  },

  async updateGuarantor (request) {
    if (!request.id) {
      throw new Error('提交数据不合法!ID为空')
    }
    action = `Update/${request.id}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async deleteGuarantor (guarantorId) {
    if (!guarantorId) {
      throw new Error('GuarantorId为空')
    }
    action = `Delete/${guarantorId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async preAuditGuarantor (guarantorId, request) {
    if (!guarantorId) {
      throw new Error('GuarantorId为空')
    }
    if (!request.timestamp) {
      request.timestamp = Date.now()
    }
    action = `PreAuditGuarantor/${guarantorId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async auditGuarantor (guarantorId, request) {
    if (!guarantorId) {
      throw new Error('GuarantorId为空')
    }
    if (!request.timestamp) {
      request.timestamp = Date.now()
    }
    action = `AuditGuarantor/${guarantorId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async addGuarantorToIndustry (query) {
    let querys = {
      guarantorId: null,
      industryId: null,
      varieties: null,
      minRate: null,
      singleLimit: null,
      regionalAllowance: null
    }
    Object.assign(querys, query)
    action = `AddGuarantorToIndustry`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async updateGuarantorIndustry (query) {
    let querys = {
      id: null,
      varieties: null,
      minRate: null,
      singleLimit: null,
      regionalAllowance: null
    }
    Object.assign(querys, query)
    action = `UpdateGuarantorIndustry`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async removeIndustryFromGuarantor (tid) {
    action = `RemoveIndustryFromGuarantor/${tid}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: null
    }
    return base.request(reqModel)
  },

  async auditIndustrialGuarantor (request) {
    // let querys = {
    //   id: null,
    //   varieties: null,
    //   minRate: null,
    //   singleLimit: null,
    //   regionalAllowance: null,
    //   pass: true,
    //   auditorUserId: null,
    //   comment: null
    // }
    // Object.assign(querys, query)
    // if (!querys.id) {
    //   throw new Error('数据不完整')
    // }
    // if (!querys.pass && !querys.reason) {
    //   throw new Error('原因必须填写')
    // }
    if (!request.timestamp) {
      request.timestamp = Date.now()
    }
    action = `AuditIndustrialGuarantor`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async addGuarantorToCity (query) {
    let querys = {
      guarantorId: null,
      cityId: null,
      varieties: null,
      minRate: null,
      singleLimit: null,
      regionalAllowance: null
    }
    Object.assign(querys, query)
    action = `AddGuarantorToCity`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async updateGuarantorCity (query) {
    let querys = {
      id: null,
      varieties: null,
      minRate: null,
      singleLimit: null,
      regionalAllowance: null
    }
    Object.assign(querys, query)
    action = `UpdateGuarantorCity`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async removeCityFromGuarantor (tid) {
    action = `RemoveCityFromGuarantor/${tid}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: null
    }
    return base.request(reqModel)
  },
  
  async auditRegionalGuarantor (request) {
    // let querys = {
    //   id: null,
    //   varieties: null,
    //   minRate: null,
    //   singleLimit: null * 100,
    //   regionalAllowance: null,
    //   pass: true,
    //   auditorUserId: null,
    //   comment: null
    // }
    // Object.assign(querys, query)
    // if (!querys.id) {
    //   throw new Error('数据不完整')
    // }
    // if (!querys.pass && !querys.reason) {
    //   throw new Error('原因必须填写')
    // }
    if (!request.timestamp) {
      request.timestamp = Date.now()
    }
    action = `AuditRegionalGuarantor`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async setException (request) {
    if (!request.timestamp) {
      request.timestamp = Date.now()
    }
    action = `Exception`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async removeException (request) {
    if (!request.timestamp) {
      request.timestamp = Date.now()
    }
    action = `RemoveException`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async getUploadParams (prefix) {
    if (!prefix) {
      throw new Error('参数错误')
    }
    action = `GetUploadParams/${prefix}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: null
    }
    return base.request(reqModel)
  }
}

export default Guarantor